import React from "react";
import { Link } from "react-router-dom";

const ContactUs = ({data}) => {
  return (
    <div className="flex flex-col md:flex-row w-full md:h-screen font-mono">
      {/* Left Side - Background Image & Heading */}
      <div
        className="w-full md:w-1/2 flex items-center justify-center bg-cover bg-center md:p-10 py-10 md:py-0 text-white "
        style={{
          backgroundImage: `url(${data.image})`,
        }}
      >
        <h1
          className="md:text-8xl text-6xl font-bold max-w-[80%] leading-tight"
          dangerouslySetInnerHTML={{ __html: data.headline }}
        ></h1>
      </div>

      {/* Right Side - Contact Details */}
      <div className="w-full md:w-1/2 bg-gray-100 flex flex-col justify-between md:p-16 p-4  space-y-10">
        <h2 className="text-lg font-bold text-gray-800 uppercase text-left">
          {data.helpHeading}
        </h2>

        <p className="text-4xl font-medium text-left">{data.description}</p>

        {/* Buttons */}
        <div className="flex space-x-4 md:justify-start justify-end">
          <Link to={data.link}>
            <button className="flex items-center space-x-2 bg-[#cc673d] text-white p-3 btn-effect font-semibold px-6 py-3">
              <span>{data.linkTitle}</span>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
